import SelectorFilter from "../../tree/SelectorFilter";

/**
 * Intended for selectors with access right filtration
 */
export default class AccessRightFilter extends SelectorFilter {
    constructor(tree, searchIndex, allActiveSet, accessRight, allAccessRightGrantedSet) {
        super(tree, searchIndex, allActiveSet);
        this.allAccessRightGrantedSet = allAccessRightGrantedSet;
        this.accessRight = accessRight;
        this.accessRightSet = this.allAccessRightGrantedSet;
    }

    hasNoFilter() {
        return super.hasNoFilter() && !this.accessRightSet;
    }

    setShowUsersWithoutGrantedAccessRight(showWithout) {
        if (showWithout && this.accessRightSet) {
            this.accessRightSet = null;
            this.reFilter();
        }
        else if (!showWithout && !this.accessRightSet) {
            this.accessRightSet = this.allAccessRightGrantedSet;
            this.reFilter();
        }
    }

    doFilter() {
        let result;
        if (this.keywordSet) {
            if (this.activeOnlySet || this.accessRightSet) {
                result = this.keywordSet.clone();
                if (this.activeOnlySet) {
                    result = result.intersection(this.activeOnlySet);
                }
                if (this.accessRightSet) {
                    result = result.intersection(this.accessRightSet);
                }
                if (result.isEmpty() && !this.keywordSet.isEmpty()) {
                    result = this.keywordSet.clone();
                }
            }
            else {
                result = this.keywordSet.clone();
            }
        }
        else {
            if (this.selectedOnlySet) {
                result = this.selectedOnlySet.clone();
            }
            if (this.activeOnlySet) {
                result = this.safeIntersection(this.activeOnlySet, result);
            }
            if (this.accessRightSet) {
                result = this.safeIntersection(this.accessRightSet, result);
            }
        }

        return result;
    }

    getVisibleNodeSet(selectedNodeSet) {
        return this.safeIntersection(super.getVisibleNodeSet(selectedNodeSet), this.accessRightSet);
    }

    getClassesForEmptyMessages() {
        let classesMap = super.getClassesForEmptyMessages();

        if (!this.keywordSet && !this.selectedOnlySet && this.accessRightSet) {
            if (this.activeOnlySet) {
                classesMap[this.NO_ACTIVE_NODES_EMPTY_MESSAGE_KEY] = "showNoEnabledAccessRightGrantedUsers";
            }
            else {
                classesMap[this.NO_NODES_EMPTY_MESSAGE_KEY] = "showNoAccessRightGrantedUsers";
            }
        }
        return classesMap;
    }

    getClassNameForEmptyVisibleSelection() {
        return "showNoSelectedNodesHasDisabledOrWithoutAccessRight";
    }
}

















// WEBPACK FOOTER //
// ./web/js/hierarchySelector/userSelector/accessRight/AccessRightFilter.js